/**************************************************
 * Nombre:       Home_Suscripcion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import img_fondo from '../../../Recursos/img_suscribete.png'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../../Recursos/logo_redondo.svg'
import {useDialogo} from "../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Suscripcion from "../../Dialogos/Dialogo_Suscripcion";
import Dialogo_Politicas from "../../Dialogos/Dialogo_Politicas";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../../App";

const Home_Suscripcion = () => {
    const {sCell, masSM, sTab} = useResponsive()
    const cData = useContext(contexApp)
    const {Avisos, Cargador, iniciarCarga, nuevoAviso, terminar} = useCargador({logoRedondo: logo})
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Suscripcion})
    const {Dialogo: DialogoPol, abrir: abrirPol} = useDialogo({Componente: Dialogo_Politicas})
    const [politicas, setPoliticas] = useState([])


    useEffect(() => {

        if (cData.configuraciones) {
            setPoliticas(cData.configuraciones.politica_protenccion)
        }


    }, [cData.configuraciones]);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: theme.palette.primary.main,
                overflowX: 'hidden'
            }}
        >


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 4 : 6,}}
            >

                <Cargador/>
                <Avisos/>
                <Dialogo/>
                <DialogoPol/>

                <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{py: 0, pr: sCell ? 0 : 6}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}>


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: !masSM ? 6 : 0}}>
                            <Typography
                                sx={{
                                    fontFamily: 'Dm Serif Display',
                                    fontSize: 40,
                                    fontWeight: 400,
                                    color: '#fff',
                                    lineHeight: 1,
                                    textAlign: sCell ? 'center' : 'left'
                                }}>ÚNETE A NUESTRA COMUNIDAD</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: -2}}>
                            <Typography sx={{
                                fontSize: 16,
                                fontWeight: 300,
                                color: '#fff',
                                textAlign: sCell ? 'center' : 'left'
                            }}>
                                <br/>
                                Suscríbete y recibe 10% OFF en tu primera compra
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 4, md: 4}}
                              sx={{
                                  mt: sTab ? 8 : 4,

                                  justifyContent: sCell ? 'center' : 'left',
                                  mb: !masSM ? 8 : 0
                              }}>
                            <Button
                                onClick={() => abrir()}
                                sx={{
                                    backgroundColor: '#ffffff40',
                                    border: 1,
                                    borderColor: '#fff',
                                    backdropFilter: 'blur(2px)',
                                    boxShadow: 0,
                                    px: 6
                                }}>SUSCRÍBETE</Button>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 10}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? -4 : 2, pb: sCell ? 4 : 0 }}>
                            <Typography sx={{
                                fontSize: 14,
                                color: '#fff',
                                fontWeight: 300,
                                textAlign: sCell ? 'center' : 'left'
                            }}>
                                Al registrarte, aceptas nuestra <span
                                onClick={() => abrirPol({texto: politicas})}
                                style={{textDecoration: 'underline', cursor: 'pointer'}}>Política de Privacidad</span> y
                                autorizas el uso
                                de tus datos para recibir novedades, promociones y beneficios exclusivos.
                            </Typography>
                        </Grid>


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 5}}>
                    <img src={img_fondo} width={!masSM ? '0%' : '150%'} height={'auto'}/>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Home_Suscripcion